export const EMPTY_FILTERS = {
  q: "", country: "", city: "", institution: "", subject_area: "", level: "",
  min_fee: "", max_fee: "", intake: "", study_mode: "",
};

export const catalogueParams = (filters) => Object.fromEntries(
  Object.entries(filters).filter(([, value]) => value !== "" && value !== null && value !== undefined),
);

export const formatTuition = (amount, currency = "GBP") => {
  if (amount === null || amount === undefined) return "Contact institution";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency }).format(amount / 100);
};

export const formatVerifiedDate = (value) => (
  value ? new Intl.DateTimeFormat("en-GB", { dateStyle: "medium" }).format(new Date(value)) : "Not yet verified"
);
